import { mutatorAction } from "satcheljs";
import { taskModules } from "../store/taskModule";
import type { InstanceStore } from "../store/schema/TaskModuleInstances";
import type { DialogInfo } from "../store/schema/Dialog";

function registerAction<T extends unknown[]>(name: string, callback: (store: InstanceStore, ...args: T) => void) {
    return (id: string): ((...args: T) => void) => 
    /* eslint-disable-next-line owa-custom-rules/invoke-only-in-module-scope -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE!
     *	> Function should only be invoked in module scope */
    mutatorAction(`${name}_${id}`, function (...args: T) {
        const store = taskModules().instances.get(id);
        if (store) {
            callback(store, ...args);
        }
    });
}

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function registerAction called at module scope is not allowed. This may cause unwanted side effects. */
export const registerOpenDialog: (id: string) => () => void = registerAction("OPEN_TASK_MODULE", (store: InstanceStore) => {
    store().isOpen = true;
    store().userClickTime = Date.now();
});

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function registerAction called at module scope is not allowed. This may cause unwanted side effects. */
export const registerCloseDialog: (id: string) => () => void = registerAction("CLOSE_TASK_MODULE", (store: InstanceStore) => {
    store().isOpen = false;
    store().dialogInfo = {} as DialogInfo;
});

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function registerAction called at module scope is not allowed. This may cause unwanted side effects. */
export const registerOnSubmit: (id: string) => () => void = registerAction("ON_SUBMIT_TASK_MODULE", (store: InstanceStore) => {
    store().isOpen = false;
});

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function registerAction called at module scope is not allowed. This may cause unwanted side effects. */
export const registerOnDismiss: (id: string) => () => void = registerAction("ON_DISMISS_TASK_MODULE", (store: InstanceStore) => {
    store().isOpen = false;
});

export const registerUpdateDialog: (id: string) => (dialogInfo: DialogInfo) => void = 
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function registerAction called at module scope is not allowed. This may cause unwanted side effects. */
registerAction("UPDATE_TASK_MODULE", (store: InstanceStore, dialogInfo: DialogInfo) => {
    store().dialogInfo = { ...dialogInfo };
});
